/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* BigQuery integration configuration
*/
export class BigQueryIntegrationConfig {
  'projectId'?: string;
  'dataset'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "projectId",
      "baseName": "projectId",
      "type": "string",
      "format": ""
    },
    {
      "name": "dataset",
      "baseName": "dataset",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BigQueryIntegrationConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

